import { Action } from 'redux';

export const GET_REVENUE = 'financial-report/GET_REVENUE';
export const getRevenue = (data: SelectReportData) => ({
  type: GET_REVENUE,
  payload: data,
});

export const SET_REVENUE = 'financial-report/SET_REVENUE';
export const setRevenue = (data: ReadonlyArray<ReportRevenueTable>) => ({
  type: SET_REVENUE,
  payload: data,
});
export interface SetRevenueAction extends Action<typeof SET_REVENUE> {
  readonly payload: ReadonlyArray<ReportRevenueTable>;
}

export const GET_CLIENT_ADMIN_BILLING_SUMMARY = 'financial-report/GET_CLIENT_ADMIN_BILLING_SUMMARY';
export const getClientAdminBillngSummary = (data: SelectReportData) => ({
  type: GET_CLIENT_ADMIN_BILLING_SUMMARY,
  payload: data,
});
export const SET_CLIENT_ADMIN_BILLING_SUMMARY = 'financial-report/SET_CLIENT_ADMIN_BILLING_SUMMARY';
export const setClientAdminBillngSummary = (data: ReadonlyArray<ClientAdminBillingSummariesTable>) => ({
  type: SET_CLIENT_ADMIN_BILLING_SUMMARY,
  payload: data,
});
export interface SetBillingSummaryAction extends Action<typeof SET_CLIENT_ADMIN_BILLING_SUMMARY> {
  readonly payload: ReadonlyArray<ClientAdminBillingSummariesTable>;
}
// Reconcliation statement
export const GET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT =
  'financial-report/GET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT';
export const getClientAdminReconciliationStatement = () => ({
  type: GET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT,
});
export const SET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT =
  'financial-report/SET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT';
export const setClientAdminBillngReconciliationStatement = (data: ReadonlyArray<ClientAdminBillingSummariesTable>) => ({
  type: SET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT,
  payload: data,
});
export interface SetClientAdminReconciliationAction extends Action<
  typeof SET_CLIENT_ADMIN_BILLING_RECONCILIATION_STATEMENT
> {
  readonly payload: ReadonlyArray<ClientAdminBillingSummariesTable>;
}

export const GET_REVENUE_BREAKDOWN = 'financial-report/GET_REVENUE_BREAKDOWN';
export const getRevenueBreakDown = (data: SelectReportData) => ({
  type: GET_REVENUE_BREAKDOWN,
  payload: data,
});

export const SET_REVENUE_BREAKDOWN = 'financial-report/SET_REVENUE_BREAKDOWN';
export const setRevenueBreakDown = (data: ReadonlyArray<ReportRevenueBreakDownTable>) => ({
  type: SET_REVENUE_BREAKDOWN,
  payload: data,
});

export const GET_BILLING_SUMMARIES_FEES = 'financial-report/GET_BILLING_SUMMARIES_FEES';
export const getBillingSummariesFees = (id: number) => ({
  type: GET_BILLING_SUMMARIES_FEES,
  payload: id,
});

export const SET_BILLING_SUMMARIES_FEES = 'financial-report/SET_BILLING_SUMMARIES_FEES';
export const setBillingSummariesFees = (data: BillingSummariesFeesResponse) => ({
  type: SET_BILLING_SUMMARIES_FEES,
  payload: data,
});

export const PRINT_BILLING_SUMMARIES = 'financial-report/PRINT_BILLING_SUMMARIES';
export const printBillingSummaries = (id: number) => ({
  type: PRINT_BILLING_SUMMARIES,
  payload: id,
});

export interface SetRevenueBreakDownOrderAction extends Action<typeof SET_REVENUE_BREAKDOWN> {
  readonly payload: ReadonlyArray<ReportRevenueBreakDownTable>;
}

export interface SetBillingSummariesFeesAction extends Action<typeof SET_BILLING_SUMMARIES_FEES> {
  readonly payload: BillingSummariesFeesResponse;
}

// Cash Drawer Report
export const GET_CASH_DRAWER_DATA = 'financial-report/GET_CASH_DRAWER_DATA';
export const getCashDrawerData = (data: CashDrawerReportRequest) => ({
  type: GET_CASH_DRAWER_DATA,
  payload: data,
});

export const SET_CASH_DRAWER_DATA = 'financial-report/SET_CASH_DRAWER_DATA';
export const setCashDrawerData = (data: any) => ({
  type: SET_CASH_DRAWER_DATA,
  payload: data,
});

export interface SetCashDrawerDataAction extends Action<typeof SET_CASH_DRAWER_DATA> {
  readonly payload: CashDrawerReportResponse;
}

export const SET_CASH_DRAWER_REQUEST = 'financial-report/SET_CASH_DRAWER_REQUEST';
export const setCashDrawerRequest = (data: CashDrawerReportRequest | undefined) => ({
  type: SET_CASH_DRAWER_REQUEST,
  payload: data,
});

export interface SetCashDrawerRequestAction extends Action<typeof SET_CASH_DRAWER_REQUEST> {
  readonly payload: CashDrawerReportRequest;
}

export const GENERATE_CASH_DRAWER_PDF = 'financial-report/GENERATE_CASH_DRAWER_PDF';
export const generateCashDrawerPdf = (data: CashDrawerReportRequest) => ({
  type: GENERATE_CASH_DRAWER_PDF,
  payload: data,
});

export type FinancialReportActions =
  | SetRevenueAction
  | SetBillingSummaryAction
  | SetRevenueBreakDownOrderAction
  | SetBillingSummariesFeesAction
  | SetClientAdminReconciliationAction
  | SetCashDrawerDataAction
  | SetCashDrawerRequestAction;
